import config from 'site-react/config';

export default {
  loggedOut: [
    {
      analytics: {
        event: 'Signup Clicked',
      },
      url: '/signup',
      label: 'Signup',
    },
    {
      analytics: {
        event: 'Login Clicked',
      },
      url: '/login',
      label: 'Login',
    },
  ],
  loggedIn: [
    {
      analytics: {
        event: 'Recommendations Clicked',
      },
      url: '/recommendations',
      label: 'Recommendations',
    },
  ],
  loggedInAccount: [
    {
      analytics: {
        event: 'Surveys Clicked',
      },
      label: 'Surveys',
      url: '/survey-dashboard',
    },
    {
      analytics: {
        event: 'Favourites Clicked',
      },
      url: '/favourites',
      label: 'Favourites',
    },
    {
      analytics: {
        event: 'Viewings Clicked',
      },
      url: '/viewings?utm_source=dashboard&utm_medium=desktop',
      label: 'Viewings',
    },
    {
      analytics: {
        event: 'Profile Clicked',
      },
      url: '/profile',
      label: 'Profile',
    },
    {
      analytics: {
        event: 'Change Password Clicked',
      },
      url: '/change-password',
      label: 'Change Password',
    },
    {
      analytics: {
        event: 'Inbox Clicked',
      },
      url: config.HUBBLE_INBOX_URL,
      label: 'Inbox',
    },
    {
      analytics: {
        event: 'Logout Clicked',
      },
      url: '/logout',
      label: 'Logout',
      onClick: 'logout',
    },
  ],
};
